import { stringToBytes, bytesToString } from "../../../functions/fileSizeCalc";
import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import { errorDispatch } from "../../../functions/errorDispatch";

export default {
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      id: this.$options.name,
      selectedFileIds: [],
      selectedFiles: [],
      selectedCollections: [],
      focus: true,
    };
  },
  created() {
    this.updateSelectedFiles();

    EventBus.$on("openOverlayPage", (data) => {
      if (this.id === data.id) {
        //set selected ids
        this.selectedFileIds = data.selectedFiles;
      }
    });

    EventBus.$on("updateOverlayPageStep", (data) => {
      if (this.id === data.id) {
        this.focusInput();
        this.focus = true;

        if (data.activeStepId === "collection-success") {
          this.selectedCollections = data.collections;
        }
      }
    });

    EventBus.$on(`${this.id}-add-collection`, (data) => {
      this.createCollection();
    });
  },
  methods: {
    createCollection() {
      const formData = new FormData(this.$refs.form.$refs.form);

      formData.append("folders", JSON.stringify([]));
      formData.append("files", JSON.stringify(this.selectedFileIds));

      this.$axios
        .post(`${baseUrl}/collectionadd`, formData)
        .then((r) => {
          //open the next window (collection-success)
          EventBus.$emit(`updateOverlayPageStep`, {
            id: "collect-file",
            activeStepId: "collection-success",
            collections: [{ name: formData.get("collectionname") }],
          });

          //reset the focus
          this.focus = false;
        })
        .catch((e) => {
          errorDispatch("error.collect_file");
        });
    },

    updateSelectedFiles() {
      this.selectedFiles = this.files.filter((file) => {
        return this.selectedFileIds.includes(file.id);
      });
    },

    calcTotalSize() {
      let totalBytes = 0;
      this.selectedFiles.forEach((file) => {
        totalBytes += stringToBytes(file.size);
      });

      return bytesToString(totalBytes);
    },

    spaceInfo() {
      if (this.selectedFiles.length > 0) {
        return {
          spaceName: "",
          spaceColor: "",
        };
      }

      return {};
    },

    getTotalSizes() {
      const totalSize = this.calcTotalSize();

      return {
        totalSize: totalSize.value,
        sizeName: totalSize.unit,
      };
    },

    focusInput() {
      this.focus = !this.focus;
    },
  },
  computed: {
    collectFileInfo() {
      return {
        fileCount: this.selectedFileIds.length,
        ...this.spaceInfo(),
        ...this.getTotalSizes(),
      };
    },
  },
  watch: {
    selectedFileIds() {
      this.updateSelectedFiles();
    },
  },
};
